/**
 *  @class
 *  @function SearchForm
 */
if (!customElements.get('search-form')) {
  class SearchForm extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.is_drawer = this.dataset.drawer;
      this.drawer = this.closest('#Search-Drawer');
      this.form = this.querySelector('form');
      this.button = document.querySelectorAll('.thb-quick-search');
      this.input = this.querySelector('.search-field');
      this.defaultTab = this.querySelector('.side-panel-content--initial');
      this.predictiveSearchResults = this.is_drawer ? this.querySelector('.side-panel-content--has-tabs') : this.querySelector('.thb-predictive-search');
      this.cc = this.querySelector('.searchform--click-capture');
      this.promotionTemplate = this.querySelector('.thb-predictive-search--promotion-template');
      this.promotionHydrated = false;
      this.cache = new Map();
      this.cacheLimit = 50;
      this.lastSearchTerm = '';

      this.setupEventListeners();
    }

    hydratePromotion() {
      if (!this.promotionTemplate) {
        return;
      }
      this.promotionTemplate.parentNode.insertBefore(
        this.promotionTemplate.content,
        this.promotionTemplate
      );
      this.promotionTemplate.remove();
      this.promotionTemplate = null;
      this.promotionHydrated = true;
    }

    setupEventListeners() {
      this.form.addEventListener('submit', this.onFormSubmit.bind(this));

      this.input.addEventListener('input', debounce((event) => {
        this.onChange(event);
      }, 300).bind(this));
      this.input.addEventListener('focus', debounce((event) => {
        this.onChange(event);
      }, 300).bind(this));

      /* If Rebuy Smart Search is present it takes over the search UI.
         Skip opening the theme's Search-Drawer so Rebuy's own close
         doesn't leave html.joyee-scroll-locked stuck on the page. */
      const rebuySearchActive = !!document.getElementById('rebuy-quick-view-dropdown-search');

      this.button.forEach((item) => {
        item.addEventListener('click', (event) => {
          event.preventDefault();
          if (rebuySearchActive) return false;

          this.hydratePromotion();
          if (this.is_drawer) {
            OverlayManager.open(this.drawer);
            setTimeout(() => {
              this.input.focus({
                preventScroll: true
              });
            }, 100);
          } else {
            document.body.classList.add('open-cc');
          }
          return false;
        });
      });

      if (!this.is_drawer) {
        this.onCcClickBound = this.close.bind(this);
        this.onKeyUpBound = (e) => {
          if (e.code && e.code.toUpperCase() === 'ESCAPE') {
            this.close();
          }
        };
        this.cc?.addEventListener('click', this.onCcClickBound);
        document.addEventListener('keyup', this.onKeyUpBound);
      }
    }

    disconnectedCallback() {
      if (this.onKeyUpBound) {
        document.removeEventListener('keyup', this.onKeyUpBound);
      }
      if (this.onCcClickBound && this.cc) {
        this.cc.removeEventListener('click', this.onCcClickBound);
      }
    }

    getQuery() {
      return this.input.value.trim();
    }

    onChange() {
      const searchTerm = this.getQuery();

      if (!searchTerm.length) {
        this.lastSearchTerm = '';
        this.showDefaultContent();
        return;
      }
      if (!this.is_drawer) {
        this.open();
      }
      if (searchTerm === this.lastSearchTerm) {
        return;
      }
      this.lastSearchTerm = searchTerm;
      this.showSearchResults();
      this.getSearchResults(searchTerm);
    }

    showDefaultContent() {
      if (this.predictiveSearchResults) {
        this.predictiveSearchResults.classList.remove('active');
        this.predictiveSearchResults.innerHTML = '';
      }
      if (this.defaultTab) {
        this.defaultTab.style.display = '';
      }
      if (!this.is_drawer) {
        this.close();
      }
    }

    showSearchResults() {
      if (this.defaultTab) {
        this.defaultTab.style.display = 'none';
      }
      if (this.predictiveSearchResults) {
        this.predictiveSearchResults.classList.add('active');
      }
    }

    onFormSubmit(event) {
      if (!this.getQuery().length) {
        event.preventDefault();
      }
    }

    getSearchResults(searchTerm) {
      const cached = this.cache.get(searchTerm);
      if (cached) {
        this.renderSearchResults(cached);
        return;
      }

      if (this.predictiveSearchResults) {
        this.predictiveSearchResults.classList.add('loading');
      }

      fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=product,article,query,page&${encodeURIComponent('resources[limit]')}=10&resources[options][fields]=title,product_type,vendor,variants.title,variants.sku&section_id=predictive-search`)
        .then((response) => {
          if (this.predictiveSearchResults) {
            this.predictiveSearchResults.classList.remove('loading');
          }
          if (!response.ok) {
            var error = new Error(response.status);
            throw error;
          }

          return response.text();
        })
        .then((text) => {
          const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;

          if (this.cache.size >= this.cacheLimit) {
            this.cache.delete(this.cache.keys().next().value);
          }
          this.cache.set(searchTerm, resultsMarkup);

          this.renderSearchResults(resultsMarkup);
        })
        .catch((error) => {
          throw error;
        });
    }

    renderSearchResults(resultsMarkup) {
      this.predictiveSearchResults.innerHTML = resultsMarkup;
      const submitBtn = this.predictiveSearchResults.querySelector('#search-results-submit');
      if (submitBtn) {
        if (!this.is_drawer) {
          submitBtn.classList.remove('button');
        }
        submitBtn.addEventListener('click', () => {
          this.form.submit();
        });
      }
    }

    close() {
      if (this.predictiveSearchResults) {
        this.predictiveSearchResults.setAttribute('inert', '');
      }
      document.body.classList.remove('open-search');
      document.body.classList.remove('open-cc');
    }
    open() {
      document.body.classList.add('open-search');
      if (this.predictiveSearchResults) {
        this.predictiveSearchResults.removeAttribute('inert');
      }
    }
  }
  customElements.define('search-form', SearchForm);
}